import { SharedValue, useDerivedValue } from "react-native-reanimated";
import { WidgetPos } from "../types";

export function useThisWidget(widgets: SharedValue<WidgetPos[]>, id: string) {
  return useDerivedValue((): WidgetPos => {
    const l = widgets.value.find((w) => {
      "worklet";
      return w.id === id;
    });

    if (!l) {
      return {
        c: 0,
        h: 0,
        id: "init",
        kind: "WidgetNote",
        w: 0,
        x: 0,
        y: 0,
      };
    }
    return {
      ...l,
    };
  });
}
